shadow$provide[408] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `attribute vec4 position4;
uniform vec4 geometryResolution;
uniform vec4 geometryClip;
varying float vMask;

// External
float getSample(vec4 xyzw);

void maskLevel() {
  vec4 p = min(geometryClip, position4);
  vMask = getSample(p * geometryResolution);
}
`;

};